import { jsx as h, Fragment as ye, jsxs as G } from "react/jsx-runtime";
import * as r from "react";
import ne, { forwardRef as Wt } from "react";
import { c as Ht } from "./index-SYE1cn5_.js";
import { A as Ut } from "./AngleDownIcon-CUk0ifC-.js";
import { L as Kt } from "./Label-DMBnN1_E.js";
import { T as jt } from "./Text-D6i4LEWL.js";
import { c as Ye, S as Yt, V as $t, a as zt } from "./ScrollAreaScrollbar-CrHmfqax.js";
import { r as Ue, R as Xt } from "./index-2hJuj4UN.js";
import { c as Gt, u as Zt, f as qt, z as Qt, s as Jt, R as en, e as tn, a as ot, A as nn, h as on, C as rn, b as sn, d as cn } from "./component-DnYU0GRC.js";
import { u as an } from "./index-BZPx6jYI.js";
import { V as ln } from "./index-C-I5rYZA.js";
function O(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(s) {
    if (e == null || e(s), n === !1 || !s.defaultPrevented)
      return t == null ? void 0 : t(s);
  };
}
function rt(e, t = []) {
  let n = [];
  function o(a, l) {
    const c = r.createContext(l), i = n.length;
    n = [...n, l];
    function d(y) {
      const { scope: w, children: C, ...m } = y, u = (w == null ? void 0 : w[e][i]) || c, v = r.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ h(u.Provider, { value: v, children: C });
    }
    function g(y, w) {
      const C = (w == null ? void 0 : w[e][i]) || c, m = r.useContext(C);
      if (m) return m;
      if (l !== void 0) return l;
      throw new Error(`\`${y}\` must be used within \`${a}\``);
    }
    return d.displayName = a + "Provider", [d, g];
  }
  const s = () => {
    const a = n.map((l) => r.createContext(l));
    return function(c) {
      const i = (c == null ? void 0 : c[e]) || a;
      return r.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: i } }),
        [c, i]
      );
    };
  };
  return s.scopeName = e, [o, un(s, ...t)];
}
function un(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((s) => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function(a) {
      const l = o.reduce((c, { useScope: i, scopeName: d }) => {
        const y = i(a)[`__scope${d}`];
        return { ...c, ...y };
      }, {});
      return r.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function dn(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function st(...e) {
  return (t) => e.forEach((n) => dn(n, t));
}
function D(...e) {
  return r.useCallback(st(...e), e);
}
var fe = r.forwardRef((e, t) => {
  const { children: n, ...o } = e, s = r.Children.toArray(n), a = s.find(pn);
  if (a) {
    const l = a.props.children, c = s.map((i) => i === a ? r.Children.count(l) > 1 ? r.Children.only(null) : r.isValidElement(l) ? l.props.children : null : i);
    return /* @__PURE__ */ h(Le, { ...o, ref: t, children: r.isValidElement(l) ? r.cloneElement(l, void 0, c) : null });
  }
  return /* @__PURE__ */ h(Le, { ...o, ref: t, children: n });
});
fe.displayName = "Slot";
var Le = r.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (r.isValidElement(n)) {
    const s = mn(n);
    return r.cloneElement(n, {
      ...vn(o, n.props),
      // @ts-ignore
      ref: t ? st(t, s) : s
    });
  }
  return r.Children.count(n) > 1 ? r.Children.only(null) : null;
});
Le.displayName = "SlotClone";
var fn = ({ children: e }) => /* @__PURE__ */ h(ye, { children: e });
function pn(e) {
  return r.isValidElement(e) && e.type === fn;
}
function vn(e, t) {
  const n = { ...t };
  for (const o in t) {
    const s = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? s && a ? n[o] = (...c) => {
      a(...c), s(...c);
    } : s && (n[o] = s) : o === "style" ? n[o] = { ...s, ...a } : o === "className" && (n[o] = [s, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function mn(e) {
  var o, s;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (s = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : s.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function hn(e) {
  const t = e + "CollectionProvider", [n, o] = rt(t), [s, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), l = (C) => {
    const { scope: m, children: u } = C, v = ne.useRef(null), f = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ h(s, { scope: m, itemMap: f, collectionRef: v, children: u });
  };
  l.displayName = t;
  const c = e + "CollectionSlot", i = ne.forwardRef(
    (C, m) => {
      const { scope: u, children: v } = C, f = a(c, u), p = D(m, f.collectionRef);
      return /* @__PURE__ */ h(fe, { ref: p, children: v });
    }
  );
  i.displayName = c;
  const d = e + "CollectionItemSlot", g = "data-radix-collection-item", y = ne.forwardRef(
    (C, m) => {
      const { scope: u, children: v, ...f } = C, p = ne.useRef(null), S = D(m, p), P = a(d, u);
      return ne.useEffect(() => (P.itemMap.set(p, { ref: p, ...f }), () => void P.itemMap.delete(p))), /* @__PURE__ */ h(fe, { [g]: "", ref: S, children: v });
    }
  );
  y.displayName = d;
  function w(C) {
    const m = a(e + "CollectionConsumer", C);
    return ne.useCallback(() => {
      const v = m.collectionRef.current;
      if (!v) return [];
      const f = Array.from(v.querySelectorAll(`[${g}]`));
      return Array.from(m.itemMap.values()).sort(
        (P, R) => f.indexOf(P.ref.current) - f.indexOf(R.ref.current)
      );
    }, [m.collectionRef, m.itemMap]);
  }
  return [
    { Provider: l, Slot: i, ItemSlot: y },
    w,
    o
  ];
}
var gn = r.createContext(void 0);
function Sn(e) {
  const t = r.useContext(gn);
  return e || t || "ltr";
}
var yn = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], A = yn.reduce((e, t) => {
  const n = r.forwardRef((o, s) => {
    const { asChild: a, ...l } = o, c = a ? fe : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...l, ref: s });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Cn(e, t) {
  e && Ue.flushSync(() => e.dispatchEvent(t));
}
function Z(e) {
  const t = r.useRef(e);
  return r.useEffect(() => {
    t.current = e;
  }), r.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function wn(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Z(e);
  r.useEffect(() => {
    const o = (s) => {
      s.key === "Escape" && n(s);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var En = "DismissableLayer", De = "dismissableLayer.update", bn = "dismissableLayer.pointerDownOutside", Pn = "dismissableLayer.focusOutside", $e, ct = r.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), at = r.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: s,
      onFocusOutside: a,
      onInteractOutside: l,
      onDismiss: c,
      ...i
    } = e, d = r.useContext(ct), [g, y] = r.useState(null), w = (g == null ? void 0 : g.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, C] = r.useState({}), m = D(t, (b) => y(b)), u = Array.from(d.layers), [v] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), f = u.indexOf(v), p = g ? u.indexOf(g) : -1, S = d.layersWithOutsidePointerEventsDisabled.size > 0, P = p >= f, R = xn((b) => {
      const N = b.target, k = [...d.branches].some((F) => F.contains(N));
      !P || k || (s == null || s(b), l == null || l(b), b.defaultPrevented || c == null || c());
    }, w), M = In((b) => {
      const N = b.target;
      [...d.branches].some((F) => F.contains(N)) || (a == null || a(b), l == null || l(b), b.defaultPrevented || c == null || c());
    }, w);
    return wn((b) => {
      p === d.layers.size - 1 && (o == null || o(b), !b.defaultPrevented && c && (b.preventDefault(), c()));
    }, w), r.useEffect(() => {
      if (g)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && ($e = w.body.style.pointerEvents, w.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(g)), d.layers.add(g), ze(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (w.body.style.pointerEvents = $e);
        };
    }, [g, w, n, d]), r.useEffect(() => () => {
      g && (d.layers.delete(g), d.layersWithOutsidePointerEventsDisabled.delete(g), ze());
    }, [g, d]), r.useEffect(() => {
      const b = () => C({});
      return document.addEventListener(De, b), () => document.removeEventListener(De, b);
    }, []), /* @__PURE__ */ h(
      A.div,
      {
        ...i,
        ref: m,
        style: {
          pointerEvents: S ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: O(e.onFocusCapture, M.onFocusCapture),
        onBlurCapture: O(e.onBlurCapture, M.onBlurCapture),
        onPointerDownCapture: O(
          e.onPointerDownCapture,
          R.onPointerDownCapture
        )
      }
    );
  }
);
at.displayName = En;
var Rn = "DismissableLayerBranch", Tn = r.forwardRef((e, t) => {
  const n = r.useContext(ct), o = r.useRef(null), s = D(t, o);
  return r.useEffect(() => {
    const a = o.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ h(A.div, { ...e, ref: s });
});
Tn.displayName = Rn;
function xn(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Z(e), o = r.useRef(!1), s = r.useRef(() => {
  });
  return r.useEffect(() => {
    const a = (c) => {
      if (c.target && !o.current) {
        let i = function() {
          lt(
            bn,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", s.current), s.current = i, t.addEventListener("click", s.current, { once: !0 })) : i();
      } else
        t.removeEventListener("click", s.current);
      o.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", a), t.removeEventListener("click", s.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function In(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Z(e), o = r.useRef(!1);
  return r.useEffect(() => {
    const s = (a) => {
      a.target && !o.current && lt(Pn, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", s), () => t.removeEventListener("focusin", s);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function ze() {
  const e = new CustomEvent(De);
  document.dispatchEvent(e);
}
function lt(e, t, n, { discrete: o }) {
  const s = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && s.addEventListener(e, t, { once: !0 }), o ? Cn(s, a) : s.dispatchEvent(a);
}
var _e = 0;
function Nn() {
  r.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Xe()), document.body.insertAdjacentElement("beforeend", e[1] ?? Xe()), _e++, () => {
      _e === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), _e--;
    };
  }, []);
}
function Xe() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Oe = "focusScope.autoFocusOnMount", Ae = "focusScope.autoFocusOnUnmount", Ge = { bubbles: !1, cancelable: !0 }, _n = "FocusScope", it = r.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: s,
    onUnmountAutoFocus: a,
    ...l
  } = e, [c, i] = r.useState(null), d = Z(s), g = Z(a), y = r.useRef(null), w = D(t, (u) => i(u)), C = r.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  r.useEffect(() => {
    if (o) {
      let u = function(S) {
        if (C.paused || !c) return;
        const P = S.target;
        c.contains(P) ? y.current = P : z(y.current, { select: !0 });
      }, v = function(S) {
        if (C.paused || !c) return;
        const P = S.relatedTarget;
        P !== null && (c.contains(P) || z(y.current, { select: !0 }));
      }, f = function(S) {
        if (document.activeElement === document.body)
          for (const R of S)
            R.removedNodes.length > 0 && z(c);
      };
      document.addEventListener("focusin", u), document.addEventListener("focusout", v);
      const p = new MutationObserver(f);
      return c && p.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", u), document.removeEventListener("focusout", v), p.disconnect();
      };
    }
  }, [o, c, C.paused]), r.useEffect(() => {
    if (c) {
      qe.add(C);
      const u = document.activeElement;
      if (!c.contains(u)) {
        const f = new CustomEvent(Oe, Ge);
        c.addEventListener(Oe, d), c.dispatchEvent(f), f.defaultPrevented || (On(kn(ut(c)), { select: !0 }), document.activeElement === u && z(c));
      }
      return () => {
        c.removeEventListener(Oe, d), setTimeout(() => {
          const f = new CustomEvent(Ae, Ge);
          c.addEventListener(Ae, g), c.dispatchEvent(f), f.defaultPrevented || z(u ?? document.body, { select: !0 }), c.removeEventListener(Ae, g), qe.remove(C);
        }, 0);
      };
    }
  }, [c, d, g, C]);
  const m = r.useCallback(
    (u) => {
      if (!n && !o || C.paused) return;
      const v = u.key === "Tab" && !u.altKey && !u.ctrlKey && !u.metaKey, f = document.activeElement;
      if (v && f) {
        const p = u.currentTarget, [S, P] = An(p);
        S && P ? !u.shiftKey && f === P ? (u.preventDefault(), n && z(S, { select: !0 })) : u.shiftKey && f === S && (u.preventDefault(), n && z(P, { select: !0 })) : f === p && u.preventDefault();
      }
    },
    [n, o, C.paused]
  );
  return /* @__PURE__ */ h(A.div, { tabIndex: -1, ...l, ref: w, onKeyDown: m });
});
it.displayName = _n;
function On(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (z(o, { select: t }), document.activeElement !== n) return;
}
function An(e) {
  const t = ut(e), n = Ze(t, e), o = Ze(t.reverse(), e);
  return [n, o];
}
function ut(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const s = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || s ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Ze(e, t) {
  for (const n of e)
    if (!Mn(n, { upTo: t })) return n;
}
function Mn(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Ln(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function z(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Ln(e) && t && e.select();
  }
}
var qe = Dn();
function Dn() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Qe(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Qe(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Qe(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function kn(e) {
  return e.filter((t) => t.tagName !== "A");
}
var H = globalThis != null && globalThis.document ? r.useLayoutEffect : () => {
}, Bn = r.useId || (() => {
}), Fn = 0;
function Ke(e) {
  const [t, n] = r.useState(Bn());
  return H(() => {
    n((o) => o ?? String(Fn++));
  }, [e]), t ? `radix-${t}` : "";
}
var Vn = "Portal", dt = r.forwardRef((e, t) => {
  var c;
  const { container: n, ...o } = e, [s, a] = r.useState(!1);
  H(() => a(!0), []);
  const l = n || s && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return l ? Xt.createPortal(/* @__PURE__ */ h(A.div, { ...o, ref: t }), l) : null;
});
dt.displayName = Vn;
function Je({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [o, s] = Wn({ defaultProp: t, onChange: n }), a = e !== void 0, l = a ? e : o, c = Z(n), i = r.useCallback(
    (d) => {
      if (a) {
        const y = typeof d == "function" ? d(e) : d;
        y !== e && c(y);
      } else
        s(d);
    },
    [a, e, s, c]
  );
  return [l, i];
}
function Wn({
  defaultProp: e,
  onChange: t
}) {
  const n = r.useState(e), [o] = n, s = r.useRef(o), a = Z(t);
  return r.useEffect(() => {
    s.current !== o && (a(o), s.current = o);
  }, [o, s, a]), n;
}
var X = function() {
  return X = Object.assign || function(t) {
    for (var n, o = 1, s = arguments.length; o < s; o++) {
      n = arguments[o];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, X.apply(this, arguments);
};
function Hn(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, o = Object.getOwnPropertySymbols(e); s < o.length; s++)
      t.indexOf(o[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[s]) && (n[o[s]] = e[o[s]]);
  return n;
}
function Un(e, t, n) {
  if (n || arguments.length === 2) for (var o = 0, s = t.length, a; o < s; o++)
    (a || !(o in t)) && (a || (a = Array.prototype.slice.call(t, 0, o)), a[o] = t[o]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var ft = Gt(), Me = function() {
}, Ce = r.forwardRef(function(e, t) {
  var n = r.useRef(null), o = r.useState({
    onScrollCapture: Me,
    onWheelCapture: Me,
    onTouchMoveCapture: Me
  }), s = o[0], a = o[1], l = e.forwardProps, c = e.children, i = e.className, d = e.removeScrollBar, g = e.enabled, y = e.shards, w = e.sideCar, C = e.noIsolation, m = e.inert, u = e.allowPinchZoom, v = e.as, f = v === void 0 ? "div" : v, p = e.gapMode, S = Hn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), P = w, R = Zt([n, t]), M = X(X({}, S), s);
  return r.createElement(
    r.Fragment,
    null,
    g && r.createElement(P, { sideCar: ft, removeScrollBar: d, shards: y, noIsolation: C, inert: m, setCallbacks: a, allowPinchZoom: !!u, lockRef: n, gapMode: p }),
    l ? r.cloneElement(r.Children.only(c), X(X({}, M), { ref: R })) : r.createElement(f, X({}, M, { className: i, ref: R }), c)
  );
});
Ce.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ce.classNames = {
  fullWidth: qt,
  zeroRight: Qt
};
var ke = !1;
if (typeof window < "u")
  try {
    var he = Object.defineProperty({}, "passive", {
      get: function() {
        return ke = !0, !0;
      }
    });
    window.addEventListener("test", he, he), window.removeEventListener("test", he, he);
  } catch {
    ke = !1;
  }
var ae = ke ? { passive: !1 } : !1, Kn = function(e) {
  return e.tagName === "TEXTAREA";
}, pt = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Kn(e) && n[t] === "visible")
  );
}, jn = function(e) {
  return pt(e, "overflowY");
}, Yn = function(e) {
  return pt(e, "overflowX");
}, et = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var s = vt(e, o);
    if (s) {
      var a = mt(e, o), l = a[1], c = a[2];
      if (l > c)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, $n = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, zn = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, vt = function(e, t) {
  return e === "v" ? jn(t) : Yn(t);
}, mt = function(e, t) {
  return e === "v" ? $n(t) : zn(t);
}, Xn = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Gn = function(e, t, n, o, s) {
  var a = Xn(e, window.getComputedStyle(t).direction), l = a * o, c = n.target, i = t.contains(c), d = !1, g = l > 0, y = 0, w = 0;
  do {
    var C = mt(e, c), m = C[0], u = C[1], v = C[2], f = u - v - a * m;
    (m || f) && vt(e, c) && (y += f, w += m), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !i && c !== document.body || // self content
    i && (t.contains(c) || t === c)
  );
  return (g && (Math.abs(y) < 1 || !s) || !g && (Math.abs(w) < 1 || !s)) && (d = !0), d;
}, ge = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, tt = function(e) {
  return [e.deltaX, e.deltaY];
}, nt = function(e) {
  return e && "current" in e ? e.current : e;
}, Zn = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, qn = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Qn = 0, le = [];
function Jn(e) {
  var t = r.useRef([]), n = r.useRef([0, 0]), o = r.useRef(), s = r.useState(Qn++)[0], a = r.useState(Jt)[0], l = r.useRef(e);
  r.useEffect(function() {
    l.current = e;
  }, [e]), r.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(s));
      var u = Un([e.lockRef.current], (e.shards || []).map(nt), !0).filter(Boolean);
      return u.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(s));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(s)), u.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(s));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = r.useCallback(function(u, v) {
    if ("touches" in u && u.touches.length === 2)
      return !l.current.allowPinchZoom;
    var f = ge(u), p = n.current, S = "deltaX" in u ? u.deltaX : p[0] - f[0], P = "deltaY" in u ? u.deltaY : p[1] - f[1], R, M = u.target, b = Math.abs(S) > Math.abs(P) ? "h" : "v";
    if ("touches" in u && b === "h" && M.type === "range")
      return !1;
    var N = et(b, M);
    if (!N)
      return !0;
    if (N ? R = b : (R = b === "v" ? "h" : "v", N = et(b, M)), !N)
      return !1;
    if (!o.current && "changedTouches" in u && (S || P) && (o.current = R), !R)
      return !0;
    var k = o.current || R;
    return Gn(k, v, u, k === "h" ? S : P, !0);
  }, []), i = r.useCallback(function(u) {
    var v = u;
    if (!(!le.length || le[le.length - 1] !== a)) {
      var f = "deltaY" in v ? tt(v) : ge(v), p = t.current.filter(function(R) {
        return R.name === v.type && (R.target === v.target || v.target === R.shadowParent) && Zn(R.delta, f);
      })[0];
      if (p && p.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!p) {
        var S = (l.current.shards || []).map(nt).filter(Boolean).filter(function(R) {
          return R.contains(v.target);
        }), P = S.length > 0 ? c(v, S[0]) : !l.current.noIsolation;
        P && v.cancelable && v.preventDefault();
      }
    }
  }, []), d = r.useCallback(function(u, v, f, p) {
    var S = { name: u, delta: v, target: f, should: p, shadowParent: eo(f) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== S;
      });
    }, 1);
  }, []), g = r.useCallback(function(u) {
    n.current = ge(u), o.current = void 0;
  }, []), y = r.useCallback(function(u) {
    d(u.type, tt(u), u.target, c(u, e.lockRef.current));
  }, []), w = r.useCallback(function(u) {
    d(u.type, ge(u), u.target, c(u, e.lockRef.current));
  }, []);
  r.useEffect(function() {
    return le.push(a), e.setCallbacks({
      onScrollCapture: y,
      onWheelCapture: y,
      onTouchMoveCapture: w
    }), document.addEventListener("wheel", i, ae), document.addEventListener("touchmove", i, ae), document.addEventListener("touchstart", g, ae), function() {
      le = le.filter(function(u) {
        return u !== a;
      }), document.removeEventListener("wheel", i, ae), document.removeEventListener("touchmove", i, ae), document.removeEventListener("touchstart", g, ae);
    };
  }, []);
  var C = e.removeScrollBar, m = e.inert;
  return r.createElement(
    r.Fragment,
    null,
    m ? r.createElement(a, { styles: qn(s) }) : null,
    C ? r.createElement(en, { gapMode: e.gapMode }) : null
  );
}
function eo(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const to = tn(ft, Jn);
var ht = r.forwardRef(function(e, t) {
  return r.createElement(Ce, X({}, e, { ref: t, sideCar: to }));
});
ht.classNames = Ce.classNames;
var no = [" ", "Enter", "ArrowUp", "ArrowDown"], oo = [" ", "Enter"], pe = "Select", [we, Ee, ro] = hn(pe), [ie, er] = rt(pe, [
  ro,
  ot
]), be = ot(), [so, q] = ie(pe), [co, ao] = ie(pe), gt = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: o,
    defaultOpen: s,
    onOpenChange: a,
    value: l,
    defaultValue: c,
    onValueChange: i,
    dir: d,
    name: g,
    autoComplete: y,
    disabled: w,
    required: C
  } = e, m = be(t), [u, v] = r.useState(null), [f, p] = r.useState(null), [S, P] = r.useState(!1), R = Sn(d), [M = !1, b] = Je({
    prop: o,
    defaultProp: s,
    onChange: a
  }), [N, k] = Je({
    prop: l,
    defaultProp: c,
    onChange: i
  }), F = r.useRef(null), J = u ? !!u.closest("form") : !0, [V, j] = r.useState(/* @__PURE__ */ new Set()), Y = Array.from(V).map((L) => L.props.value).join(";");
  return /* @__PURE__ */ h(cn, { ...m, children: /* @__PURE__ */ G(
    so,
    {
      required: C,
      scope: t,
      trigger: u,
      onTriggerChange: v,
      valueNode: f,
      onValueNodeChange: p,
      valueNodeHasChildren: S,
      onValueNodeHasChildrenChange: P,
      contentId: Ke(),
      value: N,
      onValueChange: k,
      open: M,
      onOpenChange: b,
      dir: R,
      triggerPointerDownPosRef: F,
      disabled: w,
      children: [
        /* @__PURE__ */ h(we.Provider, { scope: t, children: /* @__PURE__ */ h(
          co,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: r.useCallback((L) => {
              j((W) => new Set(W).add(L));
            }, []),
            onNativeOptionRemove: r.useCallback((L) => {
              j((W) => {
                const U = new Set(W);
                return U.delete(L), U;
              });
            }, []),
            children: n
          }
        ) }),
        J ? /* @__PURE__ */ G(
          Bt,
          {
            "aria-hidden": !0,
            required: C,
            tabIndex: -1,
            name: g,
            autoComplete: y,
            value: N,
            onChange: (L) => k(L.target.value),
            disabled: w,
            children: [
              N === void 0 ? /* @__PURE__ */ h("option", { value: "" }) : null,
              Array.from(V)
            ]
          },
          Y
        ) : null
      ]
    }
  ) });
};
gt.displayName = pe;
var St = "SelectTrigger", yt = r.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: o = !1, ...s } = e, a = be(n), l = q(St, n), c = l.disabled || o, i = D(t, l.onTriggerChange), d = Ee(n), [g, y, w] = Ft((m) => {
      const u = d().filter((p) => !p.disabled), v = u.find((p) => p.value === l.value), f = Vt(u, m, v);
      f !== void 0 && l.onValueChange(f.value);
    }), C = () => {
      c || (l.onOpenChange(!0), w());
    };
    return /* @__PURE__ */ h(nn, { asChild: !0, ...a, children: /* @__PURE__ */ h(
      A.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": l.contentId,
        "aria-expanded": l.open,
        "aria-required": l.required,
        "aria-autocomplete": "none",
        dir: l.dir,
        "data-state": l.open ? "open" : "closed",
        disabled: c,
        "data-disabled": c ? "" : void 0,
        "data-placeholder": kt(l.value) ? "" : void 0,
        ...s,
        ref: i,
        onClick: O(s.onClick, (m) => {
          m.currentTarget.focus();
        }),
        onPointerDown: O(s.onPointerDown, (m) => {
          const u = m.target;
          u.hasPointerCapture(m.pointerId) && u.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && (C(), l.triggerPointerDownPosRef.current = {
            x: Math.round(m.pageX),
            y: Math.round(m.pageY)
          }, m.preventDefault());
        }),
        onKeyDown: O(s.onKeyDown, (m) => {
          const u = g.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && y(m.key), !(u && m.key === " ") && no.includes(m.key) && (C(), m.preventDefault());
        })
      }
    ) });
  }
);
yt.displayName = St;
var Ct = "SelectValue", wt = r.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: s, children: a, placeholder: l = "", ...c } = e, i = q(Ct, n), { onValueNodeHasChildrenChange: d } = i, g = a !== void 0, y = D(t, i.onValueNodeChange);
    return H(() => {
      d(g);
    }, [d, g]), /* @__PURE__ */ h(
      A.span,
      {
        ...c,
        ref: y,
        style: { pointerEvents: "none" },
        children: kt(i.value) ? /* @__PURE__ */ h(ye, { children: l }) : a
      }
    );
  }
);
wt.displayName = Ct;
var lo = "SelectIcon", Et = r.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: o, ...s } = e;
    return /* @__PURE__ */ h(A.span, { "aria-hidden": !0, ...s, ref: t, children: o || "▼" });
  }
);
Et.displayName = lo;
var io = "SelectPortal", bt = (e) => /* @__PURE__ */ h(dt, { asChild: !0, ...e });
bt.displayName = io;
var re = "SelectContent", Pt = r.forwardRef(
  (e, t) => {
    const n = q(re, e.__scopeSelect), [o, s] = r.useState();
    if (H(() => {
      s(new DocumentFragment());
    }, []), !n.open) {
      const a = o;
      return a ? Ue.createPortal(
        /* @__PURE__ */ h(Rt, { scope: e.__scopeSelect, children: /* @__PURE__ */ h(we.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ h("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ h(Tt, { ...e, ref: t });
  }
);
Pt.displayName = re;
var K = 10, [Rt, Q] = ie(re), uo = "SelectContentImpl", Tt = r.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: o = "item-aligned",
      onCloseAutoFocus: s,
      onEscapeKeyDown: a,
      onPointerDownOutside: l,
      //
      // PopperContent props
      side: c,
      sideOffset: i,
      align: d,
      alignOffset: g,
      arrowPadding: y,
      collisionBoundary: w,
      collisionPadding: C,
      sticky: m,
      hideWhenDetached: u,
      avoidCollisions: v,
      //
      ...f
    } = e, p = q(re, n), [S, P] = r.useState(null), [R, M] = r.useState(null), b = D(t, (E) => P(E)), [N, k] = r.useState(null), [F, J] = r.useState(
      null
    ), V = Ee(n), [j, Y] = r.useState(!1), L = r.useRef(!1);
    r.useEffect(() => {
      if (S) return on(S);
    }, [S]), Nn();
    const W = r.useCallback(
      (E) => {
        const [_, ...B] = V().map((x) => x.ref.current), [I] = B.slice(-1), T = document.activeElement;
        for (const x of E)
          if (x === T || (x == null || x.scrollIntoView({ block: "nearest" }), x === _ && R && (R.scrollTop = 0), x === I && R && (R.scrollTop = R.scrollHeight), x == null || x.focus(), document.activeElement !== T)) return;
      },
      [V, R]
    ), U = r.useCallback(
      () => W([N, S]),
      [W, N, S]
    );
    r.useEffect(() => {
      j && U();
    }, [j, U]);
    const { onOpenChange: se, triggerPointerDownPosRef: $ } = p;
    r.useEffect(() => {
      if (S) {
        let E = { x: 0, y: 0 };
        const _ = (I) => {
          var T, x;
          E = {
            x: Math.abs(Math.round(I.pageX) - (((T = $.current) == null ? void 0 : T.x) ?? 0)),
            y: Math.abs(Math.round(I.pageY) - (((x = $.current) == null ? void 0 : x.y) ?? 0))
          };
        }, B = (I) => {
          E.x <= 10 && E.y <= 10 ? I.preventDefault() : S.contains(I.target) || se(!1), document.removeEventListener("pointermove", _), $.current = null;
        };
        return $.current !== null && (document.addEventListener("pointermove", _), document.addEventListener("pointerup", B, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", _), document.removeEventListener("pointerup", B, { capture: !0 });
        };
      }
    }, [S, se, $]), r.useEffect(() => {
      const E = () => se(!1);
      return window.addEventListener("blur", E), window.addEventListener("resize", E), () => {
        window.removeEventListener("blur", E), window.removeEventListener("resize", E);
      };
    }, [se]);
    const [Pe, ve] = Ft((E) => {
      const _ = V().filter((T) => !T.disabled), B = _.find((T) => T.ref.current === document.activeElement), I = Vt(_, E, B);
      I && setTimeout(() => I.ref.current.focus());
    }), Re = r.useCallback(
      (E, _, B) => {
        const I = !L.current && !B;
        (p.value !== void 0 && p.value === _ || I) && (k(E), I && (L.current = !0));
      },
      [p.value]
    ), Te = r.useCallback(() => S == null ? void 0 : S.focus(), [S]), ce = r.useCallback(
      (E, _, B) => {
        const I = !L.current && !B;
        (p.value !== void 0 && p.value === _ || I) && J(E);
      },
      [p.value]
    ), me = o === "popper" ? Be : xt, ue = me === Be ? {
      side: c,
      sideOffset: i,
      align: d,
      alignOffset: g,
      arrowPadding: y,
      collisionBoundary: w,
      collisionPadding: C,
      sticky: m,
      hideWhenDetached: u,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ h(
      Rt,
      {
        scope: n,
        content: S,
        viewport: R,
        onViewportChange: M,
        itemRefCallback: Re,
        selectedItem: N,
        onItemLeave: Te,
        itemTextRefCallback: ce,
        focusSelectedItem: U,
        selectedItemText: F,
        position: o,
        isPositioned: j,
        searchRef: Pe,
        children: /* @__PURE__ */ h(ht, { as: fe, allowPinchZoom: !0, children: /* @__PURE__ */ h(
          it,
          {
            asChild: !0,
            trapped: p.open,
            onMountAutoFocus: (E) => {
              E.preventDefault();
            },
            onUnmountAutoFocus: O(s, (E) => {
              var _;
              (_ = p.trigger) == null || _.focus({ preventScroll: !0 }), E.preventDefault();
            }),
            children: /* @__PURE__ */ h(
              at,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: l,
                onFocusOutside: (E) => E.preventDefault(),
                onDismiss: () => p.onOpenChange(!1),
                children: /* @__PURE__ */ h(
                  me,
                  {
                    role: "listbox",
                    id: p.contentId,
                    "data-state": p.open ? "open" : "closed",
                    dir: p.dir,
                    onContextMenu: (E) => E.preventDefault(),
                    ...f,
                    ...ue,
                    onPlaced: () => Y(!0),
                    ref: b,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...f.style
                    },
                    onKeyDown: O(f.onKeyDown, (E) => {
                      const _ = E.ctrlKey || E.altKey || E.metaKey;
                      if (E.key === "Tab" && E.preventDefault(), !_ && E.key.length === 1 && ve(E.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(E.key)) {
                        let I = V().filter((T) => !T.disabled).map((T) => T.ref.current);
                        if (["ArrowUp", "End"].includes(E.key) && (I = I.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(E.key)) {
                          const T = E.target, x = I.indexOf(T);
                          I = I.slice(x + 1);
                        }
                        setTimeout(() => W(I)), E.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Tt.displayName = uo;
var fo = "SelectItemAlignedPosition", xt = r.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...s } = e, a = q(re, n), l = Q(re, n), [c, i] = r.useState(null), [d, g] = r.useState(null), y = D(t, (b) => g(b)), w = Ee(n), C = r.useRef(!1), m = r.useRef(!0), { viewport: u, selectedItem: v, selectedItemText: f, focusSelectedItem: p } = l, S = r.useCallback(() => {
    if (a.trigger && a.valueNode && c && d && u && v && f) {
      const b = a.trigger.getBoundingClientRect(), N = d.getBoundingClientRect(), k = a.valueNode.getBoundingClientRect(), F = f.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const T = F.left - N.left, x = k.left - T, ee = b.left - x, te = b.width + ee, xe = Math.max(te, N.width), Ie = window.innerWidth - K, Ne = Ye(x, [K, Ie - xe]);
        c.style.minWidth = te + "px", c.style.left = Ne + "px";
      } else {
        const T = N.right - F.right, x = window.innerWidth - k.right - T, ee = window.innerWidth - b.right - x, te = b.width + ee, xe = Math.max(te, N.width), Ie = window.innerWidth - K, Ne = Ye(x, [K, Ie - xe]);
        c.style.minWidth = te + "px", c.style.right = Ne + "px";
      }
      const J = w(), V = window.innerHeight - K * 2, j = u.scrollHeight, Y = window.getComputedStyle(d), L = parseInt(Y.borderTopWidth, 10), W = parseInt(Y.paddingTop, 10), U = parseInt(Y.borderBottomWidth, 10), se = parseInt(Y.paddingBottom, 10), $ = L + W + j + se + U, Pe = Math.min(v.offsetHeight * 5, $), ve = window.getComputedStyle(u), Re = parseInt(ve.paddingTop, 10), Te = parseInt(ve.paddingBottom, 10), ce = b.top + b.height / 2 - K, me = V - ce, ue = v.offsetHeight / 2, E = v.offsetTop + ue, _ = L + W + E, B = $ - _;
      if (_ <= ce) {
        const T = v === J[J.length - 1].ref.current;
        c.style.bottom = "0px";
        const x = d.clientHeight - u.offsetTop - u.offsetHeight, ee = Math.max(
          me,
          ue + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (T ? Te : 0) + x + U
        ), te = _ + ee;
        c.style.height = te + "px";
      } else {
        const T = v === J[0].ref.current;
        c.style.top = "0px";
        const ee = Math.max(
          ce,
          L + u.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (T ? Re : 0) + ue
        ) + B;
        c.style.height = ee + "px", u.scrollTop = _ - ce + u.offsetTop;
      }
      c.style.margin = `${K}px 0`, c.style.minHeight = Pe + "px", c.style.maxHeight = V + "px", o == null || o(), requestAnimationFrame(() => C.current = !0);
    }
  }, [
    w,
    a.trigger,
    a.valueNode,
    c,
    d,
    u,
    v,
    f,
    a.dir,
    o
  ]);
  H(() => S(), [S]);
  const [P, R] = r.useState();
  H(() => {
    d && R(window.getComputedStyle(d).zIndex);
  }, [d]);
  const M = r.useCallback(
    (b) => {
      b && m.current === !0 && (S(), p == null || p(), m.current = !1);
    },
    [S, p]
  );
  return /* @__PURE__ */ h(
    vo,
    {
      scope: n,
      contentWrapper: c,
      shouldExpandOnScrollRef: C,
      onScrollButtonChange: M,
      children: /* @__PURE__ */ h(
        "div",
        {
          ref: i,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: P
          },
          children: /* @__PURE__ */ h(
            A.div,
            {
              ...s,
              ref: y,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...s.style
              }
            }
          )
        }
      )
    }
  );
});
xt.displayName = fo;
var po = "SelectPopperPosition", Be = r.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: o = "start",
    collisionPadding: s = K,
    ...a
  } = e, l = be(n);
  return /* @__PURE__ */ h(
    rn,
    {
      ...l,
      ...a,
      ref: t,
      align: o,
      collisionPadding: s,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Be.displayName = po;
var [vo, je] = ie(re, {}), Fe = "SelectViewport", It = r.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: o, ...s } = e, a = Q(Fe, n), l = je(Fe, n), c = D(t, a.onViewportChange), i = r.useRef(0);
    return /* @__PURE__ */ G(ye, { children: [
      /* @__PURE__ */ h(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ h(we.Slot, { scope: n, children: /* @__PURE__ */ h(
        A.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...s,
          ref: c,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            overflow: "auto",
            ...s.style
          },
          onScroll: O(s.onScroll, (d) => {
            const g = d.currentTarget, { contentWrapper: y, shouldExpandOnScrollRef: w } = l;
            if (w != null && w.current && y) {
              const C = Math.abs(i.current - g.scrollTop);
              if (C > 0) {
                const m = window.innerHeight - K * 2, u = parseFloat(y.style.minHeight), v = parseFloat(y.style.height), f = Math.max(u, v);
                if (f < m) {
                  const p = f + C, S = Math.min(m, p), P = p - S;
                  y.style.height = S + "px", y.style.bottom === "0px" && (g.scrollTop = P > 0 ? P : 0, y.style.justifyContent = "flex-end");
                }
              }
            }
            i.current = g.scrollTop;
          })
        }
      ) })
    ] });
  }
);
It.displayName = Fe;
var Nt = "SelectGroup", [mo, ho] = ie(Nt), go = r.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, s = Ke();
    return /* @__PURE__ */ h(mo, { scope: n, id: s, children: /* @__PURE__ */ h(A.div, { role: "group", "aria-labelledby": s, ...o, ref: t }) });
  }
);
go.displayName = Nt;
var _t = "SelectLabel", So = r.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, s = ho(_t, n);
    return /* @__PURE__ */ h(A.div, { id: s.id, ...o, ref: t });
  }
);
So.displayName = _t;
var Se = "SelectItem", [yo, Ot] = ie(Se), At = r.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: o,
      disabled: s = !1,
      textValue: a,
      ...l
    } = e, c = q(Se, n), i = Q(Se, n), d = c.value === o, [g, y] = r.useState(a ?? ""), [w, C] = r.useState(!1), m = D(
      t,
      (f) => {
        var p;
        return (p = i.itemRefCallback) == null ? void 0 : p.call(i, f, o, s);
      }
    ), u = Ke(), v = () => {
      s || (c.onValueChange(o), c.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ h(
      yo,
      {
        scope: n,
        value: o,
        disabled: s,
        textId: u,
        isSelected: d,
        onItemTextChange: r.useCallback((f) => {
          y((p) => p || ((f == null ? void 0 : f.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ h(
          we.ItemSlot,
          {
            scope: n,
            value: o,
            disabled: s,
            textValue: g,
            children: /* @__PURE__ */ h(
              A.div,
              {
                role: "option",
                "aria-labelledby": u,
                "data-highlighted": w ? "" : void 0,
                "aria-selected": d && w,
                "data-state": d ? "checked" : "unchecked",
                "aria-disabled": s || void 0,
                "data-disabled": s ? "" : void 0,
                tabIndex: s ? void 0 : -1,
                ...l,
                ref: m,
                onFocus: O(l.onFocus, () => C(!0)),
                onBlur: O(l.onBlur, () => C(!1)),
                onPointerUp: O(l.onPointerUp, v),
                onPointerMove: O(l.onPointerMove, (f) => {
                  var p;
                  s ? (p = i.onItemLeave) == null || p.call(i) : f.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: O(l.onPointerLeave, (f) => {
                  var p;
                  f.currentTarget === document.activeElement && ((p = i.onItemLeave) == null || p.call(i));
                }),
                onKeyDown: O(l.onKeyDown, (f) => {
                  var S;
                  ((S = i.searchRef) == null ? void 0 : S.current) !== "" && f.key === " " || (oo.includes(f.key) && v(), f.key === " " && f.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
At.displayName = Se;
var de = "SelectItemText", Mt = r.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: s, ...a } = e, l = q(de, n), c = Q(de, n), i = Ot(de, n), d = ao(de, n), [g, y] = r.useState(null), w = D(
      t,
      (f) => y(f),
      i.onItemTextChange,
      (f) => {
        var p;
        return (p = c.itemTextRefCallback) == null ? void 0 : p.call(c, f, i.value, i.disabled);
      }
    ), C = g == null ? void 0 : g.textContent, m = r.useMemo(
      () => /* @__PURE__ */ h("option", { value: i.value, disabled: i.disabled, children: C }, i.value),
      [i.disabled, i.value, C]
    ), { onNativeOptionAdd: u, onNativeOptionRemove: v } = d;
    return H(() => (u(m), () => v(m)), [u, v, m]), /* @__PURE__ */ G(ye, { children: [
      /* @__PURE__ */ h(A.span, { id: i.textId, ...a, ref: w }),
      i.isSelected && l.valueNode && !l.valueNodeHasChildren ? Ue.createPortal(a.children, l.valueNode) : null
    ] });
  }
);
Mt.displayName = de;
var Lt = "SelectItemIndicator", Co = r.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return Ot(Lt, n).isSelected ? /* @__PURE__ */ h(A.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
Co.displayName = Lt;
var Ve = "SelectScrollUpButton", wo = r.forwardRef((e, t) => {
  const n = Q(Ve, e.__scopeSelect), o = je(Ve, e.__scopeSelect), [s, a] = r.useState(!1), l = D(t, o.onScrollButtonChange);
  return H(() => {
    if (n.viewport && n.isPositioned) {
      let c = function() {
        const d = i.scrollTop > 0;
        a(d);
      };
      const i = n.viewport;
      return c(), i.addEventListener("scroll", c), () => i.removeEventListener("scroll", c);
    }
  }, [n.viewport, n.isPositioned]), s ? /* @__PURE__ */ h(
    Dt,
    {
      ...e,
      ref: l,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: i } = n;
        c && i && (c.scrollTop = c.scrollTop - i.offsetHeight);
      }
    }
  ) : null;
});
wo.displayName = Ve;
var We = "SelectScrollDownButton", Eo = r.forwardRef((e, t) => {
  const n = Q(We, e.__scopeSelect), o = je(We, e.__scopeSelect), [s, a] = r.useState(!1), l = D(t, o.onScrollButtonChange);
  return H(() => {
    if (n.viewport && n.isPositioned) {
      let c = function() {
        const d = i.scrollHeight - i.clientHeight, g = Math.ceil(i.scrollTop) < d;
        a(g);
      };
      const i = n.viewport;
      return c(), i.addEventListener("scroll", c), () => i.removeEventListener("scroll", c);
    }
  }, [n.viewport, n.isPositioned]), s ? /* @__PURE__ */ h(
    Dt,
    {
      ...e,
      ref: l,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: i } = n;
        c && i && (c.scrollTop = c.scrollTop + i.offsetHeight);
      }
    }
  ) : null;
});
Eo.displayName = We;
var Dt = r.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...s } = e, a = Q("SelectScrollButton", n), l = r.useRef(null), c = Ee(n), i = r.useCallback(() => {
    l.current !== null && (window.clearInterval(l.current), l.current = null);
  }, []);
  return r.useEffect(() => () => i(), [i]), H(() => {
    var g;
    const d = c().find((y) => y.ref.current === document.activeElement);
    (g = d == null ? void 0 : d.ref.current) == null || g.scrollIntoView({ block: "nearest" });
  }, [c]), /* @__PURE__ */ h(
    A.div,
    {
      "aria-hidden": !0,
      ...s,
      ref: t,
      style: { flexShrink: 0, ...s.style },
      onPointerDown: O(s.onPointerDown, () => {
        l.current === null && (l.current = window.setInterval(o, 50));
      }),
      onPointerMove: O(s.onPointerMove, () => {
        var d;
        (d = a.onItemLeave) == null || d.call(a), l.current === null && (l.current = window.setInterval(o, 50));
      }),
      onPointerLeave: O(s.onPointerLeave, () => {
        i();
      })
    }
  );
}), bo = "SelectSeparator", Po = r.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return /* @__PURE__ */ h(A.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
Po.displayName = bo;
var He = "SelectArrow", Ro = r.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, s = be(n), a = q(He, n), l = Q(He, n);
    return a.open && l.position === "popper" ? /* @__PURE__ */ h(sn, { ...s, ...o, ref: t }) : null;
  }
);
Ro.displayName = He;
function kt(e) {
  return e === "" || e === void 0;
}
var Bt = r.forwardRef(
  (e, t) => {
    const { value: n, ...o } = e, s = r.useRef(null), a = D(t, s), l = an(n);
    return r.useEffect(() => {
      const c = s.current, i = window.HTMLSelectElement.prototype, g = Object.getOwnPropertyDescriptor(
        i,
        "value"
      ).set;
      if (l !== n && g) {
        const y = new Event("change", { bubbles: !0 });
        g.call(c, n), c.dispatchEvent(y);
      }
    }, [l, n]), /* @__PURE__ */ h(ln, { asChild: !0, children: /* @__PURE__ */ h("select", { ...o, ref: a, defaultValue: n }) });
  }
);
Bt.displayName = "BubbleSelect";
function Ft(e) {
  const t = Z(e), n = r.useRef(""), o = r.useRef(0), s = r.useCallback(
    (l) => {
      const c = n.current + l;
      t(c), function i(d) {
        n.current = d, window.clearTimeout(o.current), d !== "" && (o.current = window.setTimeout(() => i(""), 1e3));
      }(c);
    },
    [t]
  ), a = r.useCallback(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return r.useEffect(() => () => window.clearTimeout(o.current), []), [n, s, a];
}
function Vt(e, t, n) {
  const s = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let l = To(e, Math.max(a, 0));
  s.length === 1 && (l = l.filter((d) => d !== n));
  const i = l.find(
    (d) => d.textValue.toLowerCase().startsWith(s.toLowerCase())
  );
  return i !== n ? i : void 0;
}
function To(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var xo = gt, Io = yt, No = wt, _o = Et, Oo = bt, Ao = Pt, Mo = It, Lo = At, Do = Mt;
const ko = "_field_1pg0r_1", Bo = "_selectButton_1pg0r_7", Fo = "_selectContent_1pg0r_25", Vo = "_selectIcon_1pg0r_39", Wo = "_scrollAreaViewport_1pg0r_43", Ho = "_selectItem_1pg0r_50", Uo = "_errorMessage_1pg0r_65", oe = {
  field: ko,
  selectButton: Bo,
  selectContent: Fo,
  selectIcon: Vo,
  scrollAreaViewport: Wo,
  selectItem: Ho,
  errorMessage: Uo
}, tr = Wt(function({
  id: t,
  label: n,
  placeholder: o,
  required: s,
  children: a,
  className: l,
  disabled: c,
  errorMessage: i,
  ...d
}, g) {
  return /* @__PURE__ */ G("div", { className: Ht(oe.field, l), children: [
    n && /* @__PURE__ */ h(Kt, { htmlFor: t, required: s, children: n }),
    /* @__PURE__ */ G(
      xo,
      {
        onValueChange: d.onValueChange,
        value: d.value,
        required: s,
        disabled: c,
        ...d,
        children: [
          /* @__PURE__ */ G(
            Io,
            {
              id: t,
              className: oe.selectButton,
              "aria-label": n,
              "data-error": !!i,
              children: [
                /* @__PURE__ */ h(No, { placeholder: o, ref: g }),
                /* @__PURE__ */ h(_o, { className: oe.selectIcon, children: /* @__PURE__ */ h(Ut, {}) })
              ]
            }
          ),
          /* @__PURE__ */ h(Oo, { children: /* @__PURE__ */ h(
            Ao,
            {
              className: oe.selectContent,
              position: "popper",
              children: /* @__PURE__ */ G(Yt, { children: [
                /* @__PURE__ */ h(
                  Mo,
                  {
                    asChild: !0,
                    className: oe.scrollAreaViewport,
                    children: /* @__PURE__ */ h($t, { style: { overflowY: void 0 }, children: a })
                  }
                ),
                /* @__PURE__ */ h(zt, { orientation: "vertical" })
              ] })
            }
          ) })
        ]
      }
    ),
    i && /* @__PURE__ */ h(jt, { variant: "caption", className: oe.errorMessage, children: i })
  ] });
}), nr = ({ children: e, value: t }) => /* @__PURE__ */ h(Lo, { value: t, className: oe.selectItem, children: /* @__PURE__ */ h(Do, { children: e }) });
export {
  tr as S,
  nr as a
};
